<mat-form-field class="w-100" luiFormField>
  <mat-label>{{ label }}</mat-label>
  <span matSuffix>
    <lui-circular-progress
      *ngIf="loading"
      mode="indeterminate"
      [diameter]="24"
      color="primary"
    ></lui-circular-progress>
  </span>
  <mat-chip-grid #chipGrid [disabled]="disabled" [required]="required">
    <mat-chip-row
      *ngFor="let option of selection.selected"
      (removed)="remove(option)"
    >
      <ng-container *ngIf="!displayWith; else displayWithOutlet">
        {{ option }}
      </ng-container>
      <ng-template #displayWithOutlet>
        {{ displayWith && displayWith(option) }}
      </ng-template>
      <button matChipRemove>
        <mat-icon svgIcon="close"></mat-icon>
      </button>
    </mat-chip-row>
    <input
      type="text"
      [placeholder]="!disabled ? placeholder : ''"
      class="w-auto"
      [formControl]="inputControl"
      [matChipInputFor]="chipGrid"
      [matAutocomplete]="auto"
      (matChipInputTokenEnd)="onInputTokenEnd($event)"
      autocomplete="off"
    />
  </mat-chip-grid>
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
    <mat-option
      *ngFor="let option of filteredOptions$ | async"
      [value]="option.option"
      [disabled]="option.selected"
    >
      <ng-container *ngIf="!optionTemplate; else templateOutlet">
        {{ option.option.label }}
      </ng-container>
      <ng-template #templateOutlet>
        <ng-container
          *ngTemplateOutlet="
            optionTemplate;
            context: { $implicit: option.option }
          "
        ></ng-container>
      </ng-template>
    </mat-option>
  </mat-autocomplete>
</mat-form-field>
